var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoanIconAddress(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".f0561273-2f71-4ff5-ba51-b95586dcfa0c{fill:#1e9bff;}.a069e63c-3d2e-4d4d-b8cd-b07eef971979{fill:#5d38de;}.f2939fb5-df32-476d-b33e-e1d69bb70d87{fill:#0a1482;}.efae3688-a33d-4e1d-81c0-3023fbcfbea3{fill:#12ffec;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a9558754-f16e-4fbd-94e3-646396338266",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f0561273-2f71-4ff5-ba51-b95586dcfa0c",
    d: "M423.33,281.67h-40a5,5,0,0,1,0-10h40a5,5,0,0,1,0,10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a069e63c-3d2e-4d4d-b8cd-b07eef971979",
    d: "M423.33,308.33h-40a5,5,0,0,1,0-10h40a5,5,0,0,1,0,10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f0561273-2f71-4ff5-ba51-b95586dcfa0c",
    d: "M423.33,335h-40a5,5,0,1,1,0-10h40a5,5,0,0,1,0,10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a069e63c-3d2e-4d4d-b8cd-b07eef971979",
    d: "M423.33,361.67h-40a5,5,0,0,1,0-10h40a5,5,0,0,1,0,10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f0561273-2f71-4ff5-ba51-b95586dcfa0c",
    d: "M423.33,388.33h-40a5,5,0,0,1,0-10h40a5,5,0,0,1,0,10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f2939fb5-df32-476d-b33e-e1d69bb70d87",
    d: "M343.33,461.67H270a5,5,0,0,1,0-10h68.33V98.74l-50.4-50.41H55V451.67h68.33a5,5,0,1,1,0,10H50a5,5,0,0,1-5-5V43.33a5,5,0,0,1,5-5H290a5,5,0,0,1,3.54,1.47l53.33,53.33a5,5,0,0,1,1.46,3.54v360A5,5,0,0,1,343.33,461.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a069e63c-3d2e-4d4d-b8cd-b07eef971979",
    d: "M177.27,141.67H83.33a5,5,0,0,1,0-10h93.94a5,5,0,0,1,0,10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a069e63c-3d2e-4d4d-b8cd-b07eef971979",
    d: "M233.64,168.33H83.33a5,5,0,0,1,0-10H233.64a5,5,0,0,1,0,10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a069e63c-3d2e-4d4d-b8cd-b07eef971979",
    d: "M290,196.33H83.33a5,5,0,0,1,0-10H290a5,5,0,0,1,0,10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a069e63c-3d2e-4d4d-b8cd-b07eef971979",
    d: "M158.48,223H83.33a5,5,0,1,1,0-10h75.15a5,5,0,1,1,0,10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f2939fb5-df32-476d-b33e-e1d69bb70d87",
    d: "M416.67,81.67H390a5,5,0,0,1-5-5V43.33a5,5,0,0,1,5-5h26.67a5,5,0,0,1,5,5V76.67A5,5,0,0,1,416.67,81.67ZM395,71.67h16.67V48.33H395Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f2939fb5-df32-476d-b33e-e1d69bb70d87",
    d: "M403.33,461.67a5,5,0,0,1-4.47-2.77l-20-40a5,5,0,0,1-.53-2.23v-340a5,5,0,0,1,5-5h40a5,5,0,0,1,5,5v340a5,5,0,0,1-.53,2.23l-20,40A5,5,0,0,1,403.33,461.67Zm-15-46.18,15,30,15-30V81.67h-30Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f2939fb5-df32-476d-b33e-e1d69bb70d87",
    d: "M450,215a5,5,0,0,1-5-5V108.33H383.33a5,5,0,0,1,0-10H450a5,5,0,0,1,5,5V210A5,5,0,0,1,450,215Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a069e63c-3d2e-4d4d-b8cd-b07eef971979",
    d: "M290,223H177.27a5,5,0,1,1,0-10H290a5,5,0,0,1,0,10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a069e63c-3d2e-4d4d-b8cd-b07eef971979",
    d: "M290,141.67H196.06a5,5,0,0,1,0-10H290a5,5,0,0,1,0,10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f2939fb5-df32-476d-b33e-e1d69bb70d87",
    d: "M343.33,101.67H290a5,5,0,0,1-5-5V43.33a5,5,0,1,1,10,0V91.67h48.33a5,5,0,0,1,0,10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "efae3688-a33d-4e1d-81c0-3023fbcfbea3",
    d: "M96.67,75H83.33a5,5,0,1,1,0-10H96.67a5,5,0,1,1,0,10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "efae3688-a33d-4e1d-81c0-3023fbcfbea3",
    d: "M123.33,75H110a5,5,0,0,1,0-10h13.33a5,5,0,1,1,0,10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "efae3688-a33d-4e1d-81c0-3023fbcfbea3",
    d: "M150,75H136.67a5,5,0,0,1,0-10H150a5,5,0,0,1,0,10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a069e63c-3d2e-4d4d-b8cd-b07eef971979",
    d: "M256.67,101.67H83.33a5,5,0,0,1,0-10H256.67a5,5,0,0,1,0,10Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "e8dac1ea-7c65-4103-bd2d-4f350b90bdfb",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f0561273-2f71-4ff5-ba51-b95586dcfa0c",
    d: "M196.74,483a5,5,0,0,1-3.16-1.13c-3.8-3.11-93-76.85-93-144.73a96.14,96.14,0,0,1,192.28,0c0,28.71-15.73,61.85-46.75,98.52a395.49,395.49,0,0,1-46.22,46.21A5,5,0,0,1,196.74,483Zm0-232a86.23,86.23,0,0,0-86.14,86.14c0,56.28,70.24,120.48,86.14,134.29,15.9-13.81,86.14-78,86.14-134.29A86.23,86.23,0,0,0,196.74,251Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f0561273-2f71-4ff5-ba51-b95586dcfa0c",
    d: "M196.74,383.57a46.43,46.43,0,1,1,46.43-46.43A46.48,46.48,0,0,1,196.74,383.57Zm0-82.86a36.43,36.43,0,1,0,36.43,36.43A36.48,36.48,0,0,0,196.74,300.71Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoanIconAddress);
export default __webpack_public_path__ + "static/media/LoanIcon_address.7e57482aa5de7f1b6994c748b54d3e3f.svg";
export { ForwardRef as ReactComponent };